import Route from '@ember/routing/route';

export default class WorkplaceTrialEndedRoute extends Route {
  titleToken = 'Workplace Subscription Expired';
}
